import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Row, Col, Button, Form, Card } from "react-bootstrap";
import Layout from "../../layout/Layout";
import { API } from "../../App";
import Cookies from "js-cookie";
import BasicInformation from "../../Component/KeyboardTheme/BasicInformation";
import PopupSettings from "../../Component/KeyboardTheme/PopupSettings";
import KeysSettings from "../../Component/KeyboardTheme/KeysSettings";
import OtherKeys from "../../Component/KeyboardTheme/OtherKeys";
import FontsPanel from "../../Component/KeyboardTheme/FontsPanel";
import FontsContent from "../../Component/KeyboardTheme/FontsContent";
import OtherOptionsPanel from "../../Component/KeyboardTheme/OtherOptionsPanel";
import Stepper from "../../Component/Stepper";
import { toast } from "react-toastify";

const KeyboardThemeEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [category, setCategory] = useState([]);

  const steps = [
    "Basic Information",
    "Popup Settings",
    "Keys Settings",
    "Other Keys",
    "Fonts Panel",
    "Fonts Content",
    "Other Options",
  ];

  const stepComponents = [
    BasicInformation,
    PopupSettings,
    KeysSettings,
    OtherKeys,
    FontsPanel,
    FontsContent,
    OtherOptionsPanel,
  ];

  const makeDefaultKeyStyle = () => ({
    bgType: "color",
    bgColor: ["#000000"],
    bgOrientation: null,
    borderColor: "#000000",
    borderWidth: 0,
    corners: 0,
    textColor: "#000000",
    opacity: 1,
  });

  const defaultFontsCategory = {
    textNormalColor: "#000000",
    textSelectedColor: "#000000",
    selectedBgColor: ["#000000"],
    bgOrientation: null,
    selectedBorderColor: "#000000",
    selectedBorderWidth: 0,
    corners: 0,
  };

  const [files, setFiles] = useState({
    keyboard_full_image_watch_ad: null,
    thumb_image: null,
    thumb_image_iphone: null,
    thumb_image_ipad: null,
    full_image_iphone: null,
    full_image_ipad: null,
    json_name: null,
    keyboard_bg_image: null,
    keysBgImage: null,
    keysIpadBgImage: null,
    keysBgImageLandscape: null,
    keysIpadBgImageLandscape: null,
    popupBgImage: null,
    popupBgSideImage: null,
    dropDownImage: null,
    fontsContentImage: null,
    fontsContentSelectionIconImage: null,
    gifBackImage: null,
    otherKeys: {},
  });

  const [fileNames, setFileNames] = useState({
    keyboard_full_image_watch_ad: null,
    thumb_image: null,
    thumb_image_iphone: null,
    thumb_image_ipad: null,
    full_image_iphone: null,
    full_image_ipad: null,
    json_name: null,
    keyboard_bg_image: null,
    keysBgImage: null,
    keysIpadBgImage: null,
    keysBgImageLandscape: null,
    keysIpadBgImageLandscape: null,
    popupBgImage: null,
    popupBgSideImage: null,
    dropDownImage: null,
    fontsContentImage: null,
    fontsContentSelectionIconImage: null,
    gifBackImage: null,
    otherKeys: {},
  });

  const [formData, setFormData] = useState({
    // Basic Information
    rank: "",
    name: "",
    loop_Mode: "",
    keyboardCategory: "",
    status: true,
    is_premium: true,
    is_Border: true,
    is_Watch_Video: true,

    // Popup Settings
    popup: {
      bgType: "color",
      bgColor: ["#000000"],
      bgOrientation: null,
      textColor: "#000000",
      accentKeyBGColor: "#000000",
      accentKeyTextColor: "#000000",
    },

    // Keys Settings
    keys: {
      bgType: "color",
      bgColor: ["#000000"],
      bgOrientation: null,
      borderColor: "#000000",
      borderWidth: 0,
      corners: 0,
      textColor: "#000000",
      opacity: 1,
    },

    // Other Keys
    otherKeys: {
      shift: makeDefaultKeyStyle(),
      numSwitch: makeDefaultKeyStyle(),
      emoji: makeDefaultKeyStyle(),
      audio: makeDefaultKeyStyle(),
      space: makeDefaultKeyStyle(),
      return: makeDefaultKeyStyle(),
      backspace: makeDefaultKeyStyle(),
    },

    // Fonts Panel
    fontsPanel: {
      mainBgColor: "#000000",
      separatorColor: "#000000",
      dropDownBgColor: ["#000000"],
      dropDownBgOrientation: null,
      switchBgColor: "#000000",
      category: { ...defaultFontsCategory },
      opacity: 1,
    },

    // Fonts Content Section
    fontsContent: {
      bgType: "color",
      separatorColor: "#000000",
      textNormalColor: "#000000",
      textSelectedColor: "#000000",
      bgColorOrientation: null,
      normalBgColor: ["#000000"],
      selectedBgColor: ["#000000"],
      selectedBgOrientation: null,
      selectedBorderColor: "#000000",
      selectedBorderWidth: 0,
      normalBorderColor: "#000000",
      normalBorderWidth: 0,
      opacity: 1,
      corners: 0,
      gifCategoryData: {
        searchIconColor: "#000000",
        searchTextColor: "#000000",
        searchBackgroundColor: "#000000",
        searchBorderColor: "#000000",
        searchOpacity: 1,
      },
    },

    // Other Options Panel Section
    otherOptionsPanel: {
      mainBgColor: ["#000000"],
      mainBgOrientation: null,
      optionBgNormalColor: "#000000",
      optionBgSelectedColor: "#000000",
      optionTintNormalColor: "#000000",
      optionTintSelectedColor: "#000000",
      borderBottomColor: "#000000",
    },
  });

  const onInputChange = ({ target: { name, value, dataset } }) => {
    if (name.includes(".")) {
      const keys = name.split(".");
      setFormData((prev) => {
        let updated = { ...prev };
        let nested = updated;

        for (let i = 0; i < keys.length - 1; i++) {
          nested[keys[i]] = Array.isArray(nested[keys[i]])
            ? [...nested[keys[i]]]
            : { ...nested[keys[i]] };
          nested = nested[keys[i]];
        }

        const lastKey = keys[keys.length - 1];

        if (dataset && dataset.index !== undefined) {
          const idx = parseInt(dataset.index, 10);
          if (!Array.isArray(nested[lastKey])) {
            nested[lastKey] = [nested[lastKey]];
          }
          nested[lastKey][idx] = value;
        } else {
          nested[lastKey] = value;
        }

        return updated;
      });
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleFileChange = ({ target: { name, files, dataset } }) => {
    const file = files?.[0] || null;
    if (name.startsWith("otherKeys.")) {
      const [, keyName, field] = name.split(".");
      setFiles((prev) => ({
        ...prev,
        otherKeys: {
          ...prev.otherKeys,
          [keyName]: {
            ...(prev.otherKeys[keyName] || {}),
            [field]: file,
          },
        },
      }));
      setFileNames((prev) => ({
        ...prev,
        otherKeys: {
          ...prev.otherKeys,
          [keyName]: {
            ...(prev.otherKeys[keyName] || {}),
            [field]: file?.name || "",
          },
        },
      }));
      return;
    }
    setFiles((prev) => ({
      ...prev,
      [name]: file,
    }));
    setFileNames((prev) => ({
      ...prev,
      [name]: file?.name || "",
    }));
  };

  const nextStep = () => {
    setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
  };

  const prevStep = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
  };

  const appendFormData = (formDataObj, keyPrefix, formdata) => {
    Object.entries(formDataObj).forEach(([key, value]) => {
      const fullKey = keyPrefix ? `${keyPrefix}[${key}]` : key;

      if (value === null || value === undefined) {
        formdata.append(fullKey, null);
        return;
      }

      if (value instanceof File) {
        formdata.append(fullKey, value);
        return;
      }

      if (Array.isArray(value)) {
        formdata.append(fullKey, JSON.stringify(value));
        return;
      }

      if (typeof value === "object") {
        appendFormData(value, fullKey, formdata);
        return;
      }

      formdata.append(fullKey, value);
    });

    return formdata;
  };

  const handleSubmission = async (e) => {
    e.preventDefault();

    const token = Cookies.get("jwt");
    setLoading(true);
    const formdata = new FormData();

    const mergedData = {
      ...formData,
      keyboard_full_image_watch_ad: files.keyboard_full_image_watch_ad,
      thumb_image: files.thumb_image,
      thumb_image_iphone: files.thumb_image_iphone,
      thumb_image_ipad: files.thumb_image_ipad,
      full_image_iphone: files.full_image_iphone,
      full_image_ipad: files.full_image_ipad,
      json_name: files.json_name,
      keyboard_bg_image: files.keyboard_bg_image,

      popup: {
        ...formData.popup,
        popupBgImage: files.popupBgImage,
        popupBgSideImage: files.popupBgSideImage,
      },
      keys: {
        ...formData.keys,
        bgImage: files.keysBgImage,
        keysIpadBgImage: files.keysIpadBgImage,
        keysBgImageLandscape: files.keysBgImageLandscape,
        keysIpadBgImageLandscape: files.keysIpadBgImageLandscape,
      },
      otherKeys: Object.keys(formData.otherKeys).reduce((acc, key) => {
        acc[key] = {
          ...formData.otherKeys[key],
          ...(files.otherKeys?.[key]?.bgImage
            ? { bgImage: files.otherKeys[key].bgImage }
            : {}),
          ...(files.otherKeys?.[key]?.ipadBgImage
            ? { ipadBgImage: files.otherKeys[key].ipadBgImage }
            : {}),
          ...(files.otherKeys?.[key]?.bgImageLandscape
            ? { bgImageLandscape: files.otherKeys[key].bgImageLandscape }
            : {}),
          ...(files.otherKeys?.[key]?.ipadBgImageLandscape
            ? { ipadBgImageLandscape: files.otherKeys[key].ipadBgImageLandscape }
            : {}),
        };
        return acc;
      }, {}),
      fontsPanel: {
        ...formData.fontsPanel,
        dropDownImage: files.dropDownImage,
      },
      fontsContent: {
        ...formData.fontsContent,
        fontsContentSelectionIconImage: files.fontsContentSelectionIconImage,
        gifBackImage: files.gifBackImage,
      },
    };

    console.log("🚀 ~ handleSubmission ~ formData.fontsContent:", formData);
    console.log("🚀 ~ handleSubmission ~ mergedData:", mergedData);
    const payload = appendFormData(mergedData, "", formdata);

    try {
      const res = await API.post(`/keyboardThemesUpdate/${id}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data.status) {
        toast.success("Data updated successfully!", {
          position: "bottom-right",
          autoClose: 500,
        });
        setLoading(false);
        navigate("/keyboard/theme");
      } else {
        toast.error(res.data.response_message || "Something went wrong!");
        setLoading(false);
      }
    } catch (error) {
      console.error("❌ handleSubmission error:", error);
      setLoading(false);
      toast.error(error.message || "Failed to save data!");
    }
  };

  const loadData = async (_id) => {
    try {
      //   setLoading(true);
      const token = Cookies.get("jwt");
      const singleThemeResponse = await API.post(
        `/keyboardThemes/${_id}`,
        {},
        { headers: { authorization: `Bearer ${token}` } }
      );
      const keyboardCategoriesResponse = await API.post(
        "/keyboardCategories",
        {},
        { headers: { authorization: `Bearer ${token}` } }
      );

      if (singleThemeResponse.data.response_code === 0) {
        navigate("/");
      } else {
        const d = singleThemeResponse.data.data;

        setFormData({
          rank: d.rank || "",
          name: d.name || "",
          loop_Mode: d.loop_Mode?.toString() || "",
          keyboardCategory: d.keyboardCategory?._id || "",
          status: d.status ?? true,
          is_premium: d.is_premium ?? true,
          is_Border: d.is_Border ?? true,
          is_Watch_Video: d.is_Watch_Video ?? true,

          popup: {
            bgType: d.popup?.bgType || "color",
            bgColor: d.popup?.bgColor || ["#000000"],
            bgOrientation: d.popup?.bgOrientation || null,
            textColor: d.popup?.textColor || "#000000",
            accentKeyBGColor: d.popup?.accentKeyBGColor || "#000000",
            accentKeyTextColor: d.popup?.accentKeyTextColor || "#000000",
          },

          keys: {
            bgType: d.keys?.bgType || "color",
            bgColor: d.keys?.bgColor || ["#000000"],
            bgOrientation: d.keys?.bgOrientation || null,
            borderColor: d.keys?.borderColor || "#000000",
            borderWidth: d.keys?.borderWidth || 0,
            corners: d.keys?.corners || 0,
            textColor: d.keys?.textColor || "#000000",
            opacity: d.keys?.opacity || 1,
          },

          otherKeys: d.otherKeys || formData.otherKeys,

          fontsPanel: {
            mainBgColor: d.fontsPanel?.mainBgColor || "#000000",
            separatorColor: d.fontsPanel?.separatorColor || "#000000",
            dropDownBgColor: d.fontsPanel?.dropDownBgColor || "#000000",
            dropDownBgOrientation: d.fontsPanel?.dropDownBgOrientation || null,
            switchBgColor: d.fontsPanel?.switchBgColor || "#000000",
            category: d.fontsPanel?.category || formData.fontsPanel.category,
            opacity: d.fontsPanel?.opacity || 1,
          },

          fontsContent: {
            bgType: d.fontsContent?.bgType || "color",
            separatorColor: d.fontsContent?.separatorColor || "#000000",
            textNormalColor: d.fontsContent?.textNormalColor || "#000000",
            textSelectedColor: d.fontsContent?.textSelectedColor || "#000000",
            bgColorOrientation: d.fontsContent?.bgColorOrientation || null,
            normalBgColor: d.fontsContent?.normalBgColor || ["#000000"],
            selectedBgColor: d.fontsContent?.selectedBgColor || ["#000000"],
            selectedBgOrientation:
              d.fontsContent?.selectedBgOrientation || null,
            selectedBorderColor:
              d.fontsContent?.selectedBorderColor || "#000000",
            selectedBorderWidth: d.fontsContent?.selectedBorderWidth || 0,
            normalBorderColor: d.fontsContent?.normalBorderColor || "#000000",
            normalBorderWidth: d.fontsContent?.normalBorderWidth || 0,
            opacity: d.fontsContent?.opacity || 1,
            corners: d.fontsContent?.corners || 0,
            // gifCategoryData:
            //   d.fontsContent?.gifCategoryData ||
            //   formData.fontsContent.gifCategoryData,
            gifCategoryData: {
              searchIconColor:
                d.fontsContent?.gifCategoryData?.searchIconColor ||
                formData.fontsContent.gifCategoryData.searchIconColor,
              searchTextColor:
                d.fontsContent?.gifCategoryData?.searchTextColor ||
                formData.fontsContent.gifCategoryData.searchTextColor,
              searchBackgroundColor:
                d.fontsContent?.gifCategoryData?.searchBackgroundColor ||
                formData.fontsContent.gifCategoryData.searchBackgroundColor,
              searchBorderColor:
                d.fontsContent?.gifCategoryData?.searchBorderColor ||
                formData.fontsContent.gifCategoryData.searchBorderColor,
              searchOpacity:
                d.fontsContent?.gifCategoryData?.searchOpacity ||
                formData.fontsContent.gifCategoryData.searchOpacity,
            },
          },

          otherOptionsPanel: {
            mainBgColor: d.otherOptionsPanel?.mainBgColor || ["#000000"],
            mainBgOrientation: d.otherOptionsPanel?.mainBgOrientation || null,
            optionBgNormalColor:
              d.otherOptionsPanel?.optionBgNormalColor || "#000000",
            optionBgSelectedColor:
              d.otherOptionsPanel?.optionBgSelectedColor || "#000000",
            optionTintNormalColor:
              d.otherOptionsPanel?.optionTintNormalColor || "#000000",
            optionTintSelectedColor:
              d.otherOptionsPanel?.optionTintSelectedColor || "#000000",
            borderBottomColor:
              d.otherOptionsPanel?.borderBottomColor || "#000000",
          },
        });

        setFiles({
          keyboard_full_image_watch_ad: d.keyboard_full_image_watch_ad || null,
          thumb_image: d.thumb_image || null,
          thumb_image_iphone: d.thumb_image_iphone || null,
          thumb_image_ipad: d.thumb_image_ipad || null,
          full_image_iphone: d.full_image_iphone || null,
          full_image_ipad: d.full_image_ipad || null,
          json_name: d.json_name || null,
          keysBgImage: d.keys?.bgImage || null,
          keysIpadBgImage: d.keys?.keysIpadBgImage || null,
          keysBgImageLandscape: d.keys?.keysBgImageLandscape || null,
          keysIpadBgImageLandscape: d.keys?.keysIpadBgImageLandscape || null,
          popupBgImage: d.popup?.popupBgImage || null,
          popupBgSideImage: d.popup?.popupBgSideImage || null,
          dropDownImage: d.fontsPanel?.dropDownImage || null,
          // fontsContentImage: d.fontsContent?.selectedImage || null,
          fontsContentSelectionIconImage:
            d.fontsContent?.fontsContentSelectionIconImage || null,
          gifBackImage: d.fontsContent?.gifCategoryData?.gifBackImage || null,
          otherKeys: {},
        });

        setFileNames({
          keyboard_full_image_watch_ad: d.keyboard_full_image_watch_ad
            ? d.keyboard_full_image_watch_ad.split("/").pop()
            : null,
          thumb_image: d.thumb_image ? d.thumb_image.split("/").pop() : null,
          thumb_image_iphone: d.thumb_image_iphone
            ? d.thumb_image_iphone.split("/").pop()
            : null,
          thumb_image_ipad: d.thumb_image_ipad
            ? d.thumb_image_ipad.split("/").pop()
            : null,
          full_image_iphone: d.full_image_iphone
            ? d.full_image_iphone.split("/").pop()
            : null,
          full_image_ipad: d.full_image_ipad
            ? d.full_image_ipad.split("/").pop()
            : null,
          json_name: d.json_name ? d.json_name.split("/").pop() : null,
          keyboard_bg_image: d.keyboard_bg_image
            ? d.keyboard_bg_image.split("/").pop()
            : null,
          keysBgImage: d.keys?.bgImage ? d.keys.bgImage.split("/").pop() : null,
          keysIpadBgImage: d.keys?.keysIpadBgImage
            ? d.keys.keysIpadBgImage.split("/").pop()
            : null,
          keysBgImageLandscape: d.keys?.keysBgImageLandscape
            ? d.keys.keysBgImageLandscape.split("/").pop()
            : null,
          keysIpadBgImageLandscape: d.keys?.keysIpadBgImageLandscape
            ? d.keys.keysIpadBgImageLandscape.split("/").pop()
            : null,
          popupBgImage: d.popup?.popupBgImage
            ? d.popup.popupBgImage.split("/").pop()
            : null,
          popupBgSideImage: d.popup?.popupBgSideImage
            ? d.popup.popupBgSideImage.split("/").pop()
            : null,
          dropDownImage: d.fontsPanel?.dropDownImage
            ? d.fontsPanel.dropDownImage.split("/").pop()
            : null,
          // fontsContentImage: d.fontsContent?.selectedImage
          //   ? d.fontsContent.selectedImage.split("/").pop()
          //   : null,
          fontsContentSelectionIconImage: d.fontsContent
            ?.fontsContentSelectionIconImage
            ? d.fontsContent.fontsContentSelectionIconImage.split("/").pop()
            : null,
          gifBackImage: d.fontsContent?.gifCategoryData?.gifBackImage
            ? d.fontsContent?.gifCategoryData?.gifBackImage.split("/").pop()
            : null,
          otherKeys: Object.keys(d.otherKeys || {}).reduce((acc, key) => {
            const bgImage = d.otherKeys[key]?.bgImage || null;
            const ipadBgImage = d.otherKeys[key]?.ipadBgImage || null;

            acc[key] = {
              ...d.otherKeys[key],
              bgImage: bgImage ? bgImage.split("/").pop() : null,
              ipadBgImage: ipadBgImage ? ipadBgImage.split("/").pop() : null,
              bgImageLandscape: d.otherKeys[key]?.bgImageLandscape
                ? d.otherKeys[key].bgImageLandscape.split("/").pop()
                : null,
              ipadBgImageLandscape: d.otherKeys[key]?.ipadBgImageLandscape
                ? d.otherKeys[key].ipadBgImageLandscape.split("/").pop()
                : null,
            };
            return acc;
          }, {}),
        });
        setCategory(keyboardCategoriesResponse.data.data || {});
      }
    } catch (err) {
      console.error("Error loading data:", err);
      toast.error(err.message || "Something went wrong");
    }
  };

  useEffect(() => {
    loadData(id);
  }, [id]);

  return (
    <Layout sidebar={true}>
      <div className="page-heading">
        <h3 className="my-1">Edit Keyboard Theme</h3>
      </div>
      <div className="page-content">
        <Form noValidate>
          <Row>
            <Col xs={12}>
              <Card className="mb-4">
                <Card.Header>
                  <Stepper
                    steps={steps}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    flag="edit"
                  />
                </Card.Header>
                <Card.Body>
                  {React.createElement(stepComponents[activeStep], {
                    formData,
                    setFormData,
                    onInputChange,
                    handleFileChange,
                    fileNames,
                    files,
                  })}
                </Card.Body>
                <Card.Footer className="text-end">
                  <div className="d-flex justify-content-between">
                    <Button
                      variant="primary"
                      onClick={prevStep}
                      disabled={activeStep === 0}
                    >
                      Previous
                    </Button>
                    <div className="d-flex align-items-stretch">
                      {activeStep === steps.length - 1 ? (
                        <Button
                          variant="primary"
                          className="me-2 d-flex align-items-center gap-3"
                          onClick={handleSubmission}
                          disabled={loading}
                        >
                          {loading && (
                            <div
                              className="spinner-border text-light"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          )}
                          {loading ? "Saving..." : "Save Theme"}
                        </Button>
                      ) : (
                        <Button
                          className=""
                          variant="primary"
                          onClick={nextStep}
                        >
                          Next
                        </Button>
                      )}
                      <Link to="/keyboard/theme" className="ms-2 h-100 d-block">
                        <Button variant="outline-secondary h-100 d-block">
                          Cancel
                        </Button>
                      </Link>
                    </div>
                  </div>
                </Card.Footer>
              </Card>
            </Col>
          </Row>
        </Form>
      </div>
    </Layout>
  );
};

export default KeyboardThemeEdit;
